<template>
  <div class="neu-bg full">
    <div class="flex h-full">
      <div style="width: 270px;" class="h-full">
        <div class="p-24 h-full">
          <div class="w-56 h-56 mb-12 rounded-full neu-lg text-2xl flex justify-center items-center text-gray-800">
            Quick Start
          </div>
          <div class="w-56 h-56 rounded-full neu-lg text-2xl flex justify-center items-center text-gray-800">
            Others
          </div>
        </div>
      </div>
      <div style="width: calc(100% - 270px);" class="h-full">
        <div class="p-24 h-full">
          <div class="w-full h-full neu-round neu-xl text-2xl flex justify-center items-center text-gray-800">
            <div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>